<template>
        <!--Page Header Start-->
        <section class="page-header">
            <div class="page-header-bg" style="background-image: url(assets/images/pageHeader/header.jpg); background-blend-mode: normal !important;">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <!-- <li><a href="index.html">Inicio</a></li> -->
                        <li><router-link to="/"><a href="#">Inicio</a></router-link></li>
                        <li><span>/</span></li>
                        <li>Quiénes Somos</li>
                    </ul>
                    <h2>Quiénes Somos</h2>
                </div>
            </div>
        </section>
        <!--Page Header End-->

</template>

<script>
</script>
  